import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';

import completeSeedGuideImage from './assets/images/CompleteSeedGuide.jpg';
import completeSeedGuide from './assets/pdfs/catalogues/CompleteSeedGuide.pdf';

import autumnReseedImage from './assets/images/AutumnReseed.jpg';
import autumnReseed from './assets/pdfs/catalogues/AutumnReseed.pdf';

function Landing() {
  return (
    <div className="landing-container">
      <img src="/Horizon.png" alt="Banner Logo" className="bannerlogo" />

      <div className="shift-up">
        <p>
          Horizon Seeds are a Suffolk-based agricultural seed company. We are specialists in Forage Seed, Environmental Seed, Game Cover Seed, Cereal Seed, Wild Flower & Amenity Seed, and Oil Seed Crops. Horizon Seeds operates throughout the country utilizing a network of agents and direct from our office.
        </p>

        <div className="catalogue-images">
          <div className="catalogue-images-row">
            <a
              href={completeSeedGuide}
              target="_blank"
              rel="noopener noreferrer"
              className="catalogue-image-link"
            >
              <img
                src={completeSeedGuideImage}
                alt="Complete Seed Guide"
                className="catalogue-image"
              />
            </a>

            <a
              href={autumnReseed}
              target="_blank"
              rel="noopener noreferrer"
              className="catalogue-image-link"
            >
              <img
                src={autumnReseedImage}
                alt="Autumn Reseed 2026"
                className="catalogue-image"
              />
            </a>
          </div>

          <div className="landing-navcontent">
            <p>
              Use the buttons below to browse our products or try one of our handy tools.
            </p>

            <div className="checktools-wrapper">
              <Link to="/products">
                <button>View Products</button>
              </Link>

              <Link to="/grass">
                <button>Grass Finder</button>
              </Link>

              <Link to="/maize">
                <button>Maize Selector</button>
              </Link>
            </div>

            <Link to="/mixer">
              <button className="landing-seedmix-btn">
                Cover Crop Seed Mixer
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Landing;
